import React, { useState, useEffect } from "react";
import "./Form8.scss";
import { FiArrowRight, FiX, FiPlus } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form8 = (props) => {
  const [link, setLink] = useState("");
  const disabledBtn = () => {
    if (!link)
      return true;
    return false;
  };
  const handleChange = (e) => {
    const { value } = e.target;
    setLink(value);
  };

  const handleSubmit = async () => {
    console.log(props.userData)
    await props.signup({
      userId: props.userData.signupData.userId,
      my_audition: link,
    });
    props.clicking();
  };
  return (
    <div className="Form8 w-100">
      <div className="h1">My audition video ...</div>
      <div className="note text-muted text-left">
        Connect with YouTube or Vimeo
      </div>
      <div className="row">
        <div className="col-12">
          <div className="image-upload">
            <input
              type="text"
              className="input form-control"
              placeholder="Insert link"
              value={link}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </div>

      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          onClick={() => handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup,
})(Form8);
